/* eslint-env browser */
import Vue from "vue";
import Vuex from "vuex";
import { GLOBALS, DATES } from "./../helpers";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    isLoading: true,
    maintenanceHour: 1,
    isMaintenanceTime: false,
    endDate: "2019-04-31T23:00:00Z", //yyyy-mm-ddThh:mm:ssZ - set close time in UTC
    isClosed: false,
    testing: {},

    calendar: {
      promos: 0,
      focusDay: 0,
      today: 0,
      history: null,
      redeemed: []
    },

    debug: false,

    errors: {
      "0001": "generic_advent", // user cant win another bonus for this promotion
      "0002": "generic_advent", // no bonus for this customerId and promotion available
      "0003": "generic_advent", // couldnt get random bonus
      "0004": "generic_advent", // no bonus configured for today, that matches bonus_promotion_gid and targetgroup_id from the request
      "0005": "generic_advent", // bonus not found
      "0006": "generic_advent", // awarding not allowed
      "0007": "generic_advent", // unknown bonus type
      "0008": "generic_advent", // bonus promotion not found
      "0009": "generic_advent", // user not found
      "0010": "generic_advent", // user doesnt have any claimed or unclaimed bonuses
      "0011": "generic_advent", // PAT: generic error
      "0012": "pat_eligible_advent", // PAT: player is not eligible for event
      "0013": "pat_expired_advent", // PAT: expired
      "0014": "pat_already_advent", // PAT: already opted in
      "0015": "pat_optout_advent", // PAT: opted out
      "0016": "generic_advent", // PAT: invalid
      "0017": "generic_advent", // PAT: catastrophic error
      1122: "res_122_advent", // unclaimed bonus in user account
      1000: "generic_advent" // bad request
    },

    labels: null,

    config: {
      ...GLOBALS.config
    },

    user: {
      ...GLOBALS.user
    },

    sitecore: {
      ...GLOBALS.sitecore
    }
  },

  actions: {
    updateFocusDay(context, payload) {
      context.commit("setFocusDay", payload);
    },
    updateLabels(context, payload) {
      const days = GLOBALS.GET(window, "promo.config.month.days")
        ? window.promo.config.month.days
        : DATES.DAYSIN(window.promo.config.month.index - 1);

      return new Promise(resolve => {
        const offset = 1.0;

        const currentDate =
          context.getters.isTestMode && context.state.testing.date
            ? new Date(context.state.testing.date)
            : new Date();

        let today = DATES.UTC(currentDate).getTime();
        let todayCET = new Date(today + 3600000 * offset);

        context.commit("setLabels", payload);
        context.commit("setPromoCount", days);
        context.commit("setFocusDay", today);
        context.commit("setToday", today);

        resolve();
      });
    },
    updateLoading(context, payload) {
      context.commit("setLoadingState", payload);
    },
    updateTestingVariables(context, payload) {
      context.commit("setTestingVariables", payload);
    },
    updatePromos(context, payload) {
      return new Promise(resolve => {
        context.commit("setPromos", payload);
        context.commit("setFocusDay", context.calendar.today);

        resolve();
      });
    },
    updateTargetGroup(context, payload) {
      context.commit("setTargetGroup", payload);
    },
    updateUserHistory(context, payload) {
      const redeemed = {};
      const history = {};

      return new Promise(resolve => {
        payload.forEach(item => {
          const date = new Date(item.timestamp.replace(/-/g, "/")).getDate();
          // const claimData = JSON.parse(item.data);

          // if (claimData.success === true) redeemed[`day_${date}`] = { ...item };

          history[`day_${date}`] = { ...item };
          if (item.claimed) redeemed[`day_${date}`] = { ...item };
        });

        context.commit("setUserHistory", history);
        context.commit("setRedeemed", redeemed);

        resolve();
      });
    }
  },

  getters: {
    getDebug(state) {
      return state.debug;
    },
    getAPI(state) {
      return {
        dbid: state.sitecore.bonusID,
        label: state.sitecore.portal,
        lang:
          state.sitecore.culture === undefined
            ? state.sitecore.lang
            : state.sitecore.culture,
        uid: state.user.customerId,
        targetgroup_id: state.sitecore.targetgroup_id,
        url: state.config.api,
        v2: state.config.apiv2,
        user: state.user.displayName,
        userFE: state.user.userName,
        sessionToken: state.user.sessionToken,
        userToken: state.user.userToken
      };
    },
    getCalendarConfig() {
      return window.promo.config;
    },
    getErrors(state) {
      return state.errors;
    },
    getFocusDay(state) {
      return state.calendar.focusDay;
    },
    getHistory(state) {
      return state.calendar.history;
    },
    getHost(state) {
      return state.config.host;
    },
    getIsInternetExplorer() {
      const ua = window.navigator.userAgent;

      const msie = ua.indexOf("MSIE ");
      const trident = ua.indexOf("Trident/");
      const edge = ua.indexOf("Edge/");

      if (msie > 0) return true; // IE 10 or older => return version number
      if (trident > 0) return true; // IE 11 => return version number
      if (edge > 0) return true; // Edge (IE 12+) => return version number

      return false;
    },
    getIsMobile(state) {
      return state.sitecore.isMobile;
    },
    getTcsFolder(state) {
      return state.sitecore.tcsFolder;
    },
    getLabels(state) {
      return state.labels;
    },
    getLanguage(state) {
      return state.sitecore.lang;
    },
    getMessages(state) {
      return state.sitecore.messages;
    },
    getPromoApiUrl(state) {
      return state.sitecore.apiUrl;
    },
    getBrandId(state) {
      return state.sitecore.brandId;
    },
    getChannel(state) {
      return state.sitecore.channel;
    },
    getSessionKey(state) {
      return state.sitecore.userSSO;
    },
    getPromoContent(state) {
      let days = [];
      state.sitecore.promoContent.forEach(function(item) {
        if (item.ItemName !== "banner") {
          // Extract image src
          var image = item.FieldValues.Image;
          if (image.Src) {
            item.FieldValues.Image = image.Src;
          } else {
            image = image.split('<img src="');
            image = image[1].split('"');
            image = image[0];
            item.FieldValues.Image = image;
          }

          days.push(item);
        }
      });
      return days;
    },
    getBannerContent(state) {
      let banner = {};
      state.sitecore.promoContent.forEach(function(item) {
        if (item.ItemName === "banner") {
          banner = item;
        }
      });

      return banner;
    },
    // getLabelsFile(state) {
    //   const host = state.config.host;
    //   const portal = state.sitecore.portal.replace(/\./g, "");
    //   const culture = state.sitecore.culture;
    //   return `${host}/static/data/labels/${portal}/${culture}.json?v=2`;
    // },
    getLoading(state) {
      return state.isLoading;
    },
    getLoggedIn(state) {
      return state.user.loggedIn || state.user.isLoggedIn;
    },
    getPortal(state) {
      return state.sitecore.portal;
    },
    getPortalNoDots(state) {
      return state.sitecore.portal.replace(/\./g, "");
    },
    getPMP(state) {
      return !state.user.isRealPlayer;
    },
    getPromos(state) {
      if (state.calendar.promos > 24) state.calendar.promos = 24;
      return state.calendar.promos;
    },
    getRaffleEntries(state) {
      return Object.keys(state.calendar.redeemed).length;
    },
    getRedeemed(state) {
      return state.calendar.redeemed;
    },
    getTargetGroup(state) {
      return state.user.targetGroup;
    },
    getToday(state) {
      return state.calendar.today;
    },
    getUser(state) {
      return state.user;
    },
    getMaintenanceHour(state) {
      return state.maintenanceHour;
    },
    isMaintenanceTime(state) {
      return state.isMaintenanceTime;
    },
    isClosed(state) {
      return state.isClosed;
    },
    isTestMode(state) {
      return (
        state.testing.date ||
        state.testing.targetGroupId ||
        state.testing.responseCode
      );
    },
    getTestData(state) {
      return state.testing;
    }
  },

  mutations: {
    setFocusDay(state, payload) {
      if (payload > 24) payload = 1;

      Vue.set(state.calendar, "focusDay", payload);
    },
    setLabels(state, payload) {
      Vue.set(state, "labels", payload);
    },
    setLoadingState(state, payload) {
      Vue.set(state, "isLoading", payload);
    },
    setPromos(state, payload) {
      Vue.set(state.calendar, "promos", payload);
    },
    setPromoCount(state, payload) {
      Vue.set(state.calendar, "promos", payload);
    },
    setRedeemed(state, payload) {
      Vue.set(state.calendar, "redeemed", payload);
    },
    setTargetGroup(state, payload) {
      Vue.set(state.user, "targetGroup", payload);
    },
    setToday(state, payload) {
      Vue.set(state.calendar, "today", payload);
    },

    setUserHistory(state, payload) {
      Vue.set(state.calendar, "history", payload);
    },
    setTestingVariables(state, payload) {
      Vue.set(state, "testing", payload);
    }
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js